import React from 'react'
import BulkActions from "./BulkActions";

function UserHead(props) {
    const {onCheckALl, selectAll, arrSelected} = props

    const _handleChangeChecked = (e) => {
        const {checked} = e.target

        if (typeof onCheckALl === 'function') {
            onCheckALl(checked)
        }
    }

    return (
        <thead className="CustomersHead">
        <tr>
            <th className="checkboxAll"><BulkActions selectAll={selectAll} arrSelected={arrSelected}
                                                     onChange={_handleChangeChecked}/></th>
            <th className="UserName">UserName</th>
            <th className="FullName">Tên người dùng</th>
            <th className="Dept">Công ty</th>
            <th className="Dept">Phòng ban</th>
            <th className="Status">Trạng thái</th>
            <th className="extension">Máy lẻ</th>
            <th className="calloutQueue">Nhóm gọi ra</th>
            <th className="calloutNumber">Số gọi ra</th>
            <th className="Actions"/>
        </tr>
        </thead>
    )
}

export default UserHead
